













































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import hotelOrder from "@/service/hotelService";
import { DurationTime } from "@/utils/utils.ts";
import { Checkbox, CheckboxGroup, Overlay } from "vant";
import { OrderEntity } from "@/model/Order";
import { HotelProductEntity } from "@/model/hotel";
import moment from "moment";
import * as _ from "lodash";
@Component({
  name: "hotelDetail",
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Overlay.name]: Overlay,
  },
  filters: {
    DurationTime,
  },
  methods: {
    showDateWeek(value: string) {
      let date = moment(value);
      let weeks: any = {
        0: this.$t("order_hotel_hoteldetail_ri") as string,
        1: this.$t("order_hotel_hoteldetail_yi") as string,
        2: this.$t("order_hotel_hoteldetail_er") as string,
        3: this.$t("order_hotel_hoteldetail_san") as string,
        4: this.$t("order_hotel_hoteldetail_si") as string,
        5: this.$t("order_hotel_hoteldetail_wu") as string,
        6: this.$t("order_hotel_hoteldetail_liu") as string,
      };
      let week = weeks[date.day()];

      return `${date.format("MM.DD")} (${this.$root.$t("order_hotel_hoteldetail_zhou")}${week})`;
    },
  },
})
export default class HotelDetail extends Vue {
  //data
  productData = [];
  result: any = [];
  consumerResult: any[] = [];
  isShowRules = false;
  //computed
  get UniqueID(): string {
    return (this as any).$route.query.UniqueID;
  }
  get ServiceCode(): string {
    return (this as any).$route.query.ServiceCode;
  }
  //mounted
  mounted() {
    this.getOrderDetails();
  }
  //methods
  getOrderDetails() {
    hotelOrder.OrderDetails(this.UniqueID).then(res => {
      if (res.isSucc) {
        this.productData = res.result;
      }
    });
  }
  changeProducts(value: any) {
    this.$emit("setResult", value);
  }
  changeConsumers(value: any) {
    this.$emit("setConsumerResult", value);
  }
  formatDate(value: Date, format: string = "HH:mm") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  diffDays(DepartDate: string, ArrivalDate: string) {
    let ArrivalTimes = moment(ArrivalDate);
    let DepartTimes = moment(DepartDate);
    return ArrivalTimes.diff(DepartTimes, "days");
  }
  showExtra(order: OrderEntity, product: HotelProductEntity) {
    let extraData = "";
    let extraInfo = null;

    extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "Hotel.Spec.RoomBedType" && e.IncludeID == product.ProductID);
    if (extraInfo && extraInfo.ExtraData) {
      extraData = extraInfo.ExtraData + "|";
    }

    extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "Hotel.Policy.GoodBreakfast" && e.IncludeID == product.ProductID);
    if (!extraInfo || !extraInfo.ExtraData || extraInfo.ExtraData == "0") {
      extraData += this.$root.$t("order_hotel_hoteldetail_wuzao") as string;
    } else {
      extraData += extraInfo.ExtraData;
    }

    extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "Hotel.Product.Facilities" && e.IncludeID == product.ProductID);
    if (extraInfo && extraInfo.ExtraData) {
      extraData += "|" + extraInfo.ExtraData;
    }
    return extraData;
  }
  extractExtra(code: string, order: OrderEntity, product: HotelProductEntity) {
    let extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == code && e.IncludeID == product.ProductID);
    return (extraInfo && extraInfo.ExtraData) || "";
  }
  overlayValue = [];
  showRule(rules: any) {
    if(rules == ''){
      return this.$toast(this.$root.$t('mall_modules_refund_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun'))
    }
    this.overlayValue = rules.split("。");
    this.isShowRules = true;
  }
}
